import { render, staticRenderFns } from "./TaskTypeEditor.vue?vue&type=template&id=a4ab7608&scoped=true"
import script from "./TaskTypeEditor.vue?vue&type=script&lang=js"
export * from "./TaskTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ab7608",
  null
  
)

export default component.exports